import { useCallback, useEffect, useState } from 'react';

const read = (key) => {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    const d = JSON.parse(raw);
    return d && d.data ? d : null;
  } catch { return null; }
};

/** Keeps a half-typed lead in localStorage so it survives reloads / interruptions. */
export function useLeadDraft(key, fields) {
  const [draft, setDraft] = useState(() => read(key));

  const save = useCallback((data) => {
    const typed = fields.some((k) => (data[k] || '').trim());
    if (!typed) return;
    const d = { data, savedAt: new Date().toISOString() };
    localStorage.setItem(key, JSON.stringify(d));
    setDraft(d);
  }, [key, fields]);

  const clear = useCallback(() => { localStorage.removeItem(key); setDraft(null); }, [key]);

  useEffect(() => {
    const onStorage = (e) => { if (e.key === key) setDraft(read(key)); };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [key]);

  return { draft, save, clear };
}

export function useAutosaveDraft(active, data, save) {
  useEffect(() => {
    if (!active) return undefined;
    const t = setTimeout(() => save(data), 400);
    return () => clearTimeout(t);
  }, [active, data, save]);
}

export const draftAge = (iso) => {
  const mins = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (mins < 1) return 'just now';
  if (mins < 60) return `${mins} min ago`;
  const h = Math.round(mins / 60);
  if (h < 24) return `${h} hr ago`;
  return new Date(iso).toLocaleDateString('en-GB');
};
